import { PersonaType } from '@bechtel/types';
import { t } from '@lingui/macro';

export const unassignedList = [
  { id: 1, value: PersonaType.FIELD_ENGINEER, label: t`No Field Engineer Assigned`, scope: [true, false] },
];
